<template>
  <div class="common-pay">
    <el-dialog class="pay-money-dialog" width="535px" :title="titles" :visible.sync="hide"
      :close-on-click-modal="false" center :show-close="false">
      <div slot="title" class="dialogTitle">
        <div class="close cur" @click="handleClose">
          <img src="../../assets/images/new/delete.png" alt="">
        </div>
        <div></div>
        <div class="pay_select">
          <el-select v-model="payCheckType" size="mini" placeholder="验证方式" class="handleCategroy" @change="payWay">
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled">
            </el-option>
          </el-select>
        </div>
      </div>
        <div class="orderInfo mt20">
            <div >{{orderTitle}}</div>
            <div class="orderPrice" v-if="type == 'paddleCard'">{{num}}</div>
            <div class="orderPrice" v-else><span v-if="type != 'integral'"><span class="fontSize28">￥</span></span>{{price}}</div>
            <div class="pb5" v-if="type == 'cancelCard' && giveAmount && giveAmount != 0">扣除赠金：{{giveAmount}}元</div>
            <div class="space-between" v-if="type != 'integral' && (payCheckType == 'tradeNoPwd' || payCheckType == 'tradePwd')" style="width: 300px;padding-top: 20px; border-top: 1px solid #eee;">
                <div>支付方式</div>
                <div>{{type == "paddleCard" ? '套餐卡' : "会员卡余额"}}</div>
            </div>
            <div class="space-between" v-if="type == 'integral' && payCheckType =='tradePwd'" style="width: 300px;padding-top: 10px; border-top: 1px solid #eee;">
                <div>支付方式</div>
                <div>账户积分</div>
            </div>
        </div>
        <div v-if="payCheckType == 'tradePwd'"  class="orderInput mt30">
            <el-input v-model.trim="verifyCode" placeholder="请输入密码" type="password" autocomplete="off" maxlength="6" @keyup.enter.native="dialogconfig"></el-input>
        </div>
        <div v-else-if="payCheckType == 'weixinCode'"  class="orderInput">
            <div class="smsCode" style="padding: 10px 0; border-top: 1px solid #eee;">
                <div class="mt10">验证码将发送到会员的微信</div>
                <el-link type="primary mt10" @click="sendwxCode" :disabled="!wxFlag">{{ wxFlag ? '发送验证码': wxTime +'s'}}</el-link>
            </div>
            <el-input v-model.trim="verifyCode" placeholder="请输入微信验证码" maxlength="6" @keyup.enter.native="dialogconfig" class="mt20"></el-input>
        </div>
        <div v-else-if="payCheckType == 'smsCode'" class="orderInput">
            <div class="smsCode" style="padding: 10px 0; border-top: 1px solid #eee;">
                <div class="mt10">{{mobile || userInfo.mobile}}</div>
                <el-link type="primary mt10" @click="handleSendCode" :disabled="!codeName">{{ codeName ? '发送验证码':time+'s'}}</el-link>
            </div>
            <el-input v-model.trim="verifyCode" placeholder="请输入验证码" maxlength="6" @keyup.enter.native="dialogconfig" class="mt20"></el-input>
            
        </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" :class="[type == 'cancelCard' && giveAmount && giveAmount != 0 ? 'mt10': '']" @click="dialogconfig">{{btnTitle}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { decrypt, encrypt } from "../../assets/javascript/untils";
export default {
  props: {
    hide: {
      type: Boolean,
      default: null
    },
    mobile: {
      type: String,
      default: null
    },
    bizType: {
      type: String,
      default: null
    },
    oid: {
        type: String,
        default: null
    },
    price: {
        type: Number,
        default: null
    },
    type: {
        type: String,
        default: null
    },
    num: {
        type: Number,
        default: null
    },
    memberId: {
        type: String,
        default: null
    },
    giveAmount: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      payCheckType: "tradePwd",
      verifyCode: "",
      codeName: true,
      time: 60,
      options:[
        {
          value: 'tradeNoPwd',
          label: '小额免密',
          disabled: false
        }, 
        {
          value: 'tradePwd',
          label: '密码验证',
          disabled: false
        }, 
        {
          value: 'smsCode',
          label: '短信验证',
          disabled: false
        }, 
        {
          value: 'weixinCode',
          label: '微信验证',
          disabled: false
        },
      ],
      mobileIsTrue: false,
      pay: {},
      userInfo: {},
      orderTitle: '',
      titles: '',
      btnTitle: "确定收款",
      wxFlag: true,
      wxTime: 60
    };
  },
  created() {
    this.titles = "密码验证";
    if (this.hide && this.type == 'repair') {
      this.init();
    }
  },
  watch: {
    hide (old) {
        if (old) {
          this.init()
        } else {
          this.titles = "密码验证"
        }
    }
  },
  mounted() {
      
  },
  methods: {
    init () {
      console.log(this.memberId);
        if (this.memberId) {
            this.memberInfo(this.memberId);
            return
        }
        if (!this.oid) {
            let a = JSON.parse(localStorage.getItem("shopInfo"))
            this.memberInfo(a.memberId)
            return
        }
        if (this.type == 'repair') {
          console.log(this.oid);
            this.$api.get(this.$url.repairDocument.get, {
                id: this.oid
            }).then(res => {
                if (res) {
                    this.pay = res;
                    this.memberInfo(res.memberId)
                }
            });
        } else {
            this.$api.get(this.$url.orderInfo.get, {
                id: this.oid
            })
            .then(res => {
                if (res) {
                    this.pay = res;
                    this.memberInfo(res.orderMemberVO.id)
                }
            }).catch(error => {});
        }
    },
    memberInfo (id) {
        if (this.type == "serveproduct") {
            this.orderTitle = "产品项目收款"
            this.btnTitle = "确定收款"
        } else if (this.pay.orderType == "card" || this.type == "openCard" || this.type == 'card') {
            this.orderTitle = "会员开卡收款"
            this.btnTitle = "确定开卡"
        } else if (this.type == 'repair') {
            this.orderTitle = "新建档案收款"
            this.btnTitle = "确定开卡"
        } else if (this.type == "reserve") {
            this.orderTitle = "核销订单金额"
            this.btnTitle = "确定核销"
        } else if (this.type == "cancelCard") {
            this.orderTitle = "会员销卡退款金额"
            this.btnTitle = "确定提现"
        } else if (this.type == "paddleCard") {
            this.orderTitle = "套餐划卡次数"
            this.btnTitle = "确定划卡"
        } else if (this.type == 'integral') {
          this.orderTitle = "本次积分兑换共消耗积分"
          this.btnTitle = "确定兑换"
        }
        console.log(this.pay.type,this.orderTitle)
        this.$api.get(this.$url.member.get, {
            id: id
        }).then(res => {
            if (res) {
                this.userInfo = res;
                console.log(res)
                if (res.tradeNoPwdFlag == "on" && Number(this.price < 10000) && this.type != 'cancelCard' &&  this.type != 'integral') {
                    this.titles = "小额免密"
                    this.payCheckType = 'tradeNoPwd'
                } else if (!res.passwordTradeFlag) {
                  this.titles = "短信验证";
                  this.payCheckType = 'smsCode';
                  this.options[0].disabled = true;
                  this.options[1].disabled = true;
                } else {
                    this.options[0].disabled = true;
                    this.payCheckType = 'tradePwd'
                }
            }
        })
    },
    payWay (value) {
        this.verifyCode = "";
        if (value == 'tradePwd') {
            this.titles = "密码验证"
        } else if (value == 'smsCode') {
            this.titles = "短信验证"
        } else if (value == 'tradeNoPwd') {
            this.titles = "小额免密"
        } else if (value == 'weixinCode') {
            this.titles = "微信验证"
        }
    },
    handleClose() {
        this.verifyCode = "";
        this.$emit("changeDialog", "");
    },
    dialogconfig() {
      if (this.verifyCode.length == 6 || this.payCheckType == "tradeNoPwd") {
        let arr = JSON.parse(JSON.stringify({
          payCheckType: this.payCheckType,
          verifyCode: this.verifyCode
        }))
        this.$emit("changeDialog", arr);
        this.verifyCode = "";
        if (this.type != "cancelCard" && this.type != "reserve" && this.type != 'integral') {
          // localStorage.setItem("tradeNoPwdFlag", JSON.stringify(this.userInfo))
          localStorage.setItem("newTradeNoPwdFlag", JSON.stringify(this.userInfo))
        }
      } else if (this.payCheckType == "weixinCode" && this.payCheckType.length != 6) {
        this.$message.warning("验证码长度为6位数");
      } else if (this.payCheckType == "smsCode" && this.payCheckType.length != 6) {
        this.$message.warning("验证码长度为6位数");
      } else {
        this.$message.warning("密码长度为6位数");
      }
    },
    handleSendCode() {
      if (!this.mobile && !this.userInfo.mobile) {
        return this.$message.error("您没有绑定手机号，请先去绑定手机号码！")
      }
      let arr = {
        mobile: this.mobile || this.userInfo.mobile,
        bizType: this.bizType ? this.bizType : "pay", //cardReduce
        millisecond: new Date().getTime()
      };
      
      this.$api.post(this.$url.send, encrypt(JSON.stringify(arr))).then(resp => {
          if (resp) {
            this.codeName = false;
            this.$message.success("发送成功");
            this.mobileIsTrue = true;
          } else {
            this.mobileIsTrue = false;
            this.codeName = true;
            clearInterval(auth_timetimer);
          }
          this.time = 60;
        });

      let auth_timetimer = setInterval(() => {
        if (this.time <= 0) {
          this.time = 60;
          this.codeName = true;
          this.mobileIsTrue = false;
          clearInterval(auth_timetimer);
        }
        this.time--;
      }, 1000);
    },
    sendwxCode () {
      let arr = {
        memberId: this.memberId,
        bizType: this.bizType ? this.bizType : "pay", //cardReduce
        millisecond: new Date().getTime()
      };
      console.log(arr);
      this.$api.post(this.$url.wxSend, encrypt(JSON.stringify(arr))).then(resp => {
          if (resp) {
            this.wxFlag = false;
            this.$message.success("发送成功");
          } else {
            this.codeName = true;
            clearInterval(auth_timetimer);
          }
          this.wxTime = 60;
        });

      let auth_timetimer = setInterval(() => {
        if (this.wxTime <= 0) {
          this.wxTime = 60;
          this.wxFlag = true;
          clearInterval(auth_timetimer);
        }
        this.wxTime--;
      }, 1000);
    }
  }
};
</script>

<style lang="less" >
.common-pay {
  .pay-money-dialog {
    .el-dialog {
      top: 50%;
      
      margin-top: -175px !important;
      width: 450px !important;
      min-width: 450px;
      .handleCategroy {
        width: 110px;
        .el-input {
            width: 110px;
        }
        // /deep/ .el-select-dropdown {
        //     width: 100px  !important;
        // }
      }
      .orderInfo {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-flow: column;
        font-size: 16px;
        .orderPrice {
          color: #111;
          font-weight: 700;
          padding: 10px 0;
          font-size: 36px;
        }
      }
      .orderInput {
        text-align: center;
        .el-input {
            width: 300px;
        }
        .el-input__suffix {
            line-height: 40px;
        }
      }
      .el-tab-pane {
        text-align: center;
      }
      .smsCode {
        width: 300px;
        text-align: right;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .mobile-number {
          font-size: 12px;
        }
      }
      .pay_select {
        .el-input {
          .el-input__inner {
            border: none;
            color: #111;
            font-size: 16px;
            font-weight: 700;
          }
          .el-select__caret {
            color: #999;
          }
        }
      }
      
      .el-tabs__nav-scroll {
        .el-tabs__nav {
        //   width: 100%;
          text-align: center;
          .el-tabs__active-bar {
            // left: 108px;
          }
          .el-tabs__item {
            // width: 150px;
            font-size: 16px;
          }
        }
      }
    }
    .el-dialog__body {
      height: 200px;
      padding: 0 25px 30px;
      .el-tabs {
        margin-top: 20px;
        .el-tabs__nav-wrap {
          &::after {
            height: 0;
          }
        }
      }
    }
    .el-dialog__footer {
      justify-content: center;
      width: 100%;
      padding: 0 0 40px;
      // position: absolute;
      // left: 0;
      // bottom: 0;
      overflow: hidden;
      border-top: 0;
      button {
        font-size: 16px;
      }
      .el-button + .el-button {
        margin-left: 40px;
      }
    }
  }
}
.el-select .el-input .el-select__caret {
    color: #409eff;
    font-weight: 700;
}
.dialogTitle {
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-size: 20px;
  font-weight: 700;
  .close {
    width: 14px;
    height: 14px;
    img {
      width: 100%;
      height: 100%;
      vertical-align: middle;
    }
  }
}
/deep/ .el-dialog__header {
  border: 1px solid #F5F5F5;
}
</style>